import httpService from "./httpService";

export interface UserContractExclusion {
  id: number;
  userId: string;
  conId: number;
  message: string | null;
  createdAtUtc: string;
  createdBy: string;
}

export interface CreateUserContractExclusionDto {
  userId: string;
  conId: number;
  message?: string;
}

export interface GetExclusionsResponse {
  exclusions: UserContractExclusion[];
  count: number;
}

export interface CreateExclusionResponse {
  message: string;
  exclusion: UserContractExclusion;
}

export interface DeleteExclusionResponse {
  message: string;
  deletedCount?: number;
}

const userContractExclusionsService = {
  /**
   * Get all contract exclusions for a specific user
   */
  getExclusionsForUser: async (userId: string): Promise<GetExclusionsResponse> => {
    const response = await httpService.get(`/v2/admin/user-contract-exclusions/${userId}`);
    return response.data;
  },

  /**
   * Create a new contract exclusion for a user
   */
  createExclusion: async (data: CreateUserContractExclusionDto): Promise<UserContractExclusion> => {
    const response = await httpService.post<CreateExclusionResponse>("/v2/admin/user-contract-exclusions", data);
    return response.data.exclusion;
  },

  /**
   * Delete a specific contract exclusion
   */
  deleteExclusion: async (userId: string, conId: number): Promise<void> => {
    await httpService.delete(`/v2/admin/user-contract-exclusions/${userId}/${conId}`);
  },

  /**
   * Delete all contract exclusions for a user
   */
  deleteAllExclusions: async (userId: string): Promise<number> => {
    const response = await httpService.delete<DeleteExclusionResponse>(`/v2/admin/user-contract-exclusions/${userId}`);
    return response.data.deletedCount || 0;
  },
};

export default userContractExclusionsService;
